import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Could not find a declaration file for module 'request-ip'. '/Users/aaronpierce/workspace/tac-hsiyc-web/node_modules/request-ip/lib/index.js' implicitly has an 'any' type.
import requestIp from 'request-ip';

import { navigateToVehiclePage } from '../../../utils/api';
import constructSlug from '../../../utils/construct-slug';
import Error from '../../_error';
import logger from '../../../utils/logger';
import setStatusCode from '../../../utils/set-status-code';
import { withAppProps, withAppProviders } from '../../../utils/withAppProps';
import { validateQueryParameter } from '../../../utils/validate-query-parameter';
import { getVehicleManufactureYears } from '../../../utils/apollo-requests/vehicles/get-vehicle-manufacture-years';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'make' implicitly has an 'any' type.
const ModelPage = ({ make, model, year = null, statusCode = 200 }) => {
  if (statusCode !== 200) {
    return <Error {...{ statusCode }} />;
  }
  navigateToVehiclePage(make, model, year, undefined, true);
  return null;
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'query' implicitly has an 'any' type.
const getServerSideProps = withAppProps(async ({ query, req, res }) => {
  const { make, model } = query;

  const isInputValid = validateQueryParameter(make) && validateQueryParameter(model);

  if (!isInputValid) {
    logger.error('Invalid make or model entered', {
      make,
      model,
      userIp: requestIp.getClientIp(req),
      userAgent: req.headers['User-Agent'],
      headers: req.headers,
    });
    return setStatusCode(404, res);
  }

  const data = await getVehicleManufactureYears(make, model);

  const { error, years } = data;
  if (error) {
    return setStatusCode(500, res);
  }

  if (_.isEmpty(years)) {
    logger.warn('Empty years for make and model', { make, model });
    return setStatusCode(404, res);
  }

  const latestYear = _.max(years);
  const redirect = latestYear ? `/${constructSlug(make)}/${constructSlug(model)}/${latestYear}` : null;
  if (redirect) {
    return {
      redirect: { destination: redirect, permanent: false },
    };
  }

  return {
    props: {
      make,
      model,
      year: latestYear,
    },
  };
});

ModelPage.propTypes = {
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.string,
  statusCode: PropTypes.number,
};

export default withAppProviders(ModelPage);
export { getServerSideProps };
